import { render, staticRenderFns } from "./DisplayConfig.vue?vue&type=template&id=742367fd"
import script from "./DisplayConfig.vue?vue&type=script&lang=js"
export * from "./DisplayConfig.vue?vue&type=script&lang=js"
import style0 from "./DisplayConfig.vue?vue&type=style&index=0&id=742367fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports